<template>
  <v-container id="branding" fluid fill-height align-center justify-center>
    <v-layout row wrap class="white--text ma-0">
      <v-flex xs12 class="text-center">
        <span class="display-3">Web developer</span>
      </v-flex>
      <v-flex xs12 class="text-center mt-2">
        <span class="subtitle-1">CUSTOMER AT FIRST</span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: "Branding"
  }
</script>

<style scoped>
  #branding {
    background: url("../assets/back_keybrd.png") top center no-repeat;
    background-size: cover;
    min-height: 16rem;
    text-shadow: 1px 1px 10px #000;
  }
  @media (min-width: 960px) {
    #branding {
      min-height: 20rem;
    }
  }
</style>